document.addEventListener('DOMContentLoaded', function () {
  let splide;
  let splide_class = document.querySelector('.cards-block__inner');

  function initSplide() {
    if (window.innerWidth < 1220) {
      if (!splide && splide_class) {
        splide = new Splide('.cards-block__inner', {
          perPage: 2,
          arrows: true,
          pagination: true,
          focus: 0,
          omitEnd: true,
          gap: '24px',
          breakpoints: {
            650: {
              perPage: 1,
            }
          }
        }).mount();
      }
    }
  }

  initSplide();


  window.addEventListener('resize', function () {
    initSplide();
  });
});
